import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import './style.css';
class LinkItem extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
    };
    this.state = this.initialState;
    this.handleRedirectUrl = this.handleRedirectUrl.bind(this);
  }

  handleRedirectUrl() {
    const { action } = this.props;
    this.setState({ isFetching: true });
    this.props.getRedirectUrl(action).finally(() => {
      this.setState({ isFetching: false });
    });
  }
  render() {
    const { isFetching } = this.state;
    const { text, icon, count } = this.props;
    return (
      <div
        className="form-link-item"
      >
        { isFetching && <Loading loadingContainerStyle={{ top: '56px' }} btn/> }
        <a
          className="form-link-btn"
          style={{
            textDecoration: 'none',
            userSelect: 'none',
            opacity: isFetching ? 0.1 : 1,
            cursor: isFetching ? 'not-allowed' : 'pointer',
            background: isFetching ? '#FFF !important' : undefined,
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!isFetching) {
              this.handleRedirectUrl();
            }
          }}
        >
          <div className="form-link-icon">
            <img src={icon} width="80px" height="80px" />
            {
              count > 0 && (
                <span className="form-link-counter">{count > 99 ? 'N' : count}</span>
              )
            }
          </div>
          <p className="form-link-name">
            {text}
          </p>
        </a>
      </div>
    );
  }
}
LinkItem.propTypes = {
  text: PropTypes.node,
  icon: PropTypes.node,
  action: PropTypes.string,
  getRedirectUrl: PropTypes.func,
  count: PropTypes.number,
};

export default LinkItem;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/MayoForm/components/LinkItem.js
 **/